module.exports = __webpack_public_path__ + "static/media/workflow.8f209fb0.svg";